<template>
    <div class="domain">
        <div class="main">
            <div class="pro-xq">
                <div class="adapt pro-xq-bt">
                    <h2>{{ $t("titilName") }}易记域名列表</h2>
                    <span
                        >注：域名输入时不区分大小写，所在省份全拼+tbh.net；例如湖北：hubeitbh.net</span
                    >
                </div>
                <div class="adapt pro-xq-div" style="padding: 40px">
                    <table
                        id="blank_table"
                        width="100%"
                        cellspacing="0"
                        cellpadding="0"
                        class="zzyh-form-tab"
                    >
                        <thead>
                            <tr>
                                <td>地区（拼音）</td>
                                <td>域名</td>
                                <td>地区（拼音）</td>
                                <td>域名</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>北京(Beijing)</td>
                                <td>beijingtbh.net</td>
                                <td>贵州(GuiZhou)</td>
                                <td>guizhoutbh.net</td>
                            </tr>
                            <tr>
                                <td>上海(ShangHai)</td>
                                <td>shanghaitbh.net</td>
                                <td>四川(SiChuan)</td>
                                <td>sichuantbh.net</td>
                            </tr>
                            <tr>
                                <td>天津(TianJin)</td>
                                <td>tianjintbh.net</td>
                                <td>重庆(ChongQing)</td>
                                <td>chongqingtbh.net</td>
                            </tr>
                            <tr>
                                <td>安徽(AnHui)</td>
                                <td>anhuitbh.net</td>
                                <td>福建(FuJian)</td>
                                <td>fujiantbh.net</td>
                            </tr>
                            <tr>
                                <td>广东(GuangDong)</td>
                                <td>guangdongtbh.net</td>
                                <td>广西(GuangXi)</td>
                                <td>guangxitbh.net</td>
                            </tr>
                            <tr>
                                <td>海南(HaiNan)</td>
                                <td>hainantbh.net</td>
                                <td>河北(HeBei)</td>
                                <td>hebeitbh.net</td>
                            </tr>
                            <tr>
                                <td>河南(HeNan)</td>
                                <td>henantbh.net</td>
                                <td>黑龙江(HeiLongJiang)</td>
                                <td>heilongjiangtbh.net</td>
                            </tr>
                            <tr>
                                <td>湖北(HuBei)</td>
                                <td>hubeitbh.net</td>
                                <td>湖南(HuNan)</td>
                                <td>hunantbh.net</td>
                            </tr>
                            <tr>
                                <td>吉林(JiLin)</td>
                                <td>jilintbh.net</td>
                                <td>江苏(JiangSu)</td>
                                <td>jiangsutbh.net</td>
                            </tr>
                            <tr>
                                <td>江西(JiangXi)</td>
                                <td>jiangxitbh.net</td>
                                <td>辽宁(LiaoNing)</td>
                                <td>liaoningtbh.net</td>
                            </tr>
                            <tr>
                                <td>青海(QingHai)</td>
                                <td>qinghaitbh.net</td>
                                <td>陕西(ShanXi)</td>
                                <td>shanxitbh.net</td>
                            </tr>
                            <tr>
                                <td>内蒙古(NeiMengGu)</td>
                                <td>neimenggutbh.net</td>
                                <td>山东(ShanDong)</td>
                                <td>shandongtbh.net</td>
                            </tr>
                            <tr>
                                <td>西藏(XiZang)</td>
                                <td>xizangtbh.net</td>
                                <td>新疆(XinJiang)</td>
                                <td>xinjiangtbh.net</td>
                            </tr>
                            <tr>
                                <td>云南(YunNan)</td>
                                <td>yunnantbh.net</td>
                                <td>浙江(ZheJiang)</td>
                                <td>zhejiangtbh.net</td>
                            </tr>
                            <tr>
                                <td>台湾(Taiwan)</td>
                                <td>taiwantbh.net</td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.domain {
    width: 100%;
    min-width: 1200px;
    background: url("../../assets/images/my/discount1.jpg") no-repeat center -8px !important;
    padding-top: 72px;
    .main {
        width: 1200px;
        margin: 0 auto;
        overflow: visible;
        .pro-xq {
            background: #fff;
            position: relative;
            margin-top: 50px;
            width: 100%;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
            .pro-xq-bt {
                margin: 30px 40px 0;
                padding-bottom: 35px;
                text-align: center;
                border-bottom: 2px solid #dcdcdc;
                h2 {
                    font-size: 28px;
                    font-weight: 200;
                    line-height: 60px;
                }
            }
            .adapt {
                width: auto;
                zoom: 1;
                clear: both;
            }
        }
        .zzyh-form-tab thead td {
            height: 28px;
            background: #f5f5f5;
            border: 1px solid #eaeaea;
            border-right: none;
            border-left: none;
            color: #666;
            font-weight: 600;
        }

        .zzyh-form-tab td {
            padding-left: 20px;
            line-height: 16px;
            vertical-align: middle;
            color: #666;
        }
        .zzyh-form-tab tbody td {
            height: 54px;
            border-bottom: 1px solid #e6e6e6;
        }

        .zzyh-form-tab td {
            padding-left: 20px;
            line-height: 16px;
            vertical-align: middle;
            color: #666;
        }
        .zzyh-form-tab tbody tr:nth-child(2n) td {
            background-color: #f4f4f4;
        }
    }
}
</style>